// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file assistant/v1/events.proto (package assistant.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Chat, ChatMessage } from "./assistant_pb.js";
import { file_assistant_v1_assistant } from "./assistant_pb.js";
import type { ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file assistant/v1/events.proto.
 */
export const file_assistant_v1_events: GenFile = /*@__PURE__*/
  fileDesc("Chlhc3Npc3RhbnQvdjEvZXZlbnRzLnByb3RvEgxhc3Npc3RhbnQudjEi7QEKCUNoYXRFdmVudBIxCgdjcmVhdGVkGAEgASgLMh4uYXNzaXN0YW50LnYxLkNoYXRDcmVhdGVkRXZlbnRIABIxCgd1cGRhdGVkGAIgASgLMh4uYXNzaXN0YW50LnYxLkNoYXRVcGRhdGVkRXZlbnRIABIzCghhcmNoaXZlZBgDIAEoCzIfLmFzc2lzdGFudC52MS5DaGF0QXJjaGl2ZWRFdmVudEgAEjwKDXRpdGxlX3VwZGF0ZWQYBCABKAsyIy5hc3Npc3RhbnQudjEuQ2hhdFRpdGxlVXBkYXRlZEV2ZW50SABCBwoFZXZlbnQiNAoQQ2hhdENyZWF0ZWRFdmVudBIgCgRjaGF0GAEgASgLMhIuYXNzaXN0YW50LnYxLkNoYXQiZwoQQ2hhdFVwZGF0ZWRFdmVudBIpCg1wcmV2aW91c19jaGF0GAEgASgLMhIuYXNzaXN0YW50LnYxLkNoYXQSKAoMdXBkYXRlZF9jaGF0GAIgASgLMhIuYXNzaXN0YW50LnYxLkNoYXQiNQoRQ2hhdEFyY2hpdmVkRXZlbnQSIAoEY2hhdBgBIAEoCzISLmFzc2lzdGFudC52MS5DaGF0IkIKFUNoYXRUaXRsZVVwZGF0ZWRFdmVudBIaCgdjaGF0X2lkGAEgASgLMgkudHlwZXMuSUQSDQoFdGl0bGUYAiABKAkiVQoQQ2hhdE1lc3NhZ2VFdmVudBI4CgdjcmVhdGVkGAEgASgLMiUuYXNzaXN0YW50LnYxLkNoYXRNZXNzYWdlQ3JlYXRlZEV2ZW50SABCBwoFZXZlbnQiSgoXQ2hhdE1lc3NhZ2VDcmVhdGVkRXZlbnQSLwoMY2hhdF9tZXNzYWdlGAEgASgLMhkuYXNzaXN0YW50LnYxLkNoYXRNZXNzYWdlQjdaNXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWFzc2lzdGFudC9hcGkvdjE7YXNzaXN0YW50X3YxYghlZGl0aW9uc3DoBw", [file_assistant_v1_assistant, file_types]);

/**
 * ChatEvent represents a chat event
 *
 * @generated from message assistant.v1.ChatEvent
 */
export type ChatEvent = Message<"assistant.v1.ChatEvent"> & {
  /**
   * @generated from oneof assistant.v1.ChatEvent.event
   */
  event: {
    /**
     * @generated from field: assistant.v1.ChatCreatedEvent created = 1;
     */
    value: ChatCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: assistant.v1.ChatUpdatedEvent updated = 2;
     */
    value: ChatUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: assistant.v1.ChatArchivedEvent archived = 3;
     */
    value: ChatArchivedEvent;
    case: "archived";
  } | {
    /**
     * @generated from field: assistant.v1.ChatTitleUpdatedEvent title_updated = 4;
     */
    value: ChatTitleUpdatedEvent;
    case: "titleUpdated";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message assistant.v1.ChatEvent.
 * Use `create(ChatEventSchema)` to create a new message.
 */
export const ChatEventSchema: GenMessage<ChatEvent> = /*@__PURE__*/
  messageDesc(file_assistant_v1_events, 0);

/**
 * ChatCreatedEvent is emitted when a chat is created
 *
 * @generated from message assistant.v1.ChatCreatedEvent
 */
export type ChatCreatedEvent = Message<"assistant.v1.ChatCreatedEvent"> & {
  /**
   * @generated from field: assistant.v1.Chat chat = 1;
   */
  chat?: Chat;
};

/**
 * Describes the message assistant.v1.ChatCreatedEvent.
 * Use `create(ChatCreatedEventSchema)` to create a new message.
 */
export const ChatCreatedEventSchema: GenMessage<ChatCreatedEvent> = /*@__PURE__*/
  messageDesc(file_assistant_v1_events, 1);

/**
 * ChatUpdatedEvent is emitted when a chat is updated
 *
 * @generated from message assistant.v1.ChatUpdatedEvent
 */
export type ChatUpdatedEvent = Message<"assistant.v1.ChatUpdatedEvent"> & {
  /**
   * @generated from field: assistant.v1.Chat previous_chat = 1;
   */
  previousChat?: Chat;

  /**
   * @generated from field: assistant.v1.Chat updated_chat = 2;
   */
  updatedChat?: Chat;
};

/**
 * Describes the message assistant.v1.ChatUpdatedEvent.
 * Use `create(ChatUpdatedEventSchema)` to create a new message.
 */
export const ChatUpdatedEventSchema: GenMessage<ChatUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_assistant_v1_events, 2);

/**
 * ChatArchivedEvent is emitted when a chat is archived
 *
 * @generated from message assistant.v1.ChatArchivedEvent
 */
export type ChatArchivedEvent = Message<"assistant.v1.ChatArchivedEvent"> & {
  /**
   * @generated from field: assistant.v1.Chat chat = 1;
   */
  chat?: Chat;
};

/**
 * Describes the message assistant.v1.ChatArchivedEvent.
 * Use `create(ChatArchivedEventSchema)` to create a new message.
 */
export const ChatArchivedEventSchema: GenMessage<ChatArchivedEvent> = /*@__PURE__*/
  messageDesc(file_assistant_v1_events, 3);

/**
 * ChatTitleUpdatedEvent is emitted when a chat title is updated
 *
 * @generated from message assistant.v1.ChatTitleUpdatedEvent
 */
export type ChatTitleUpdatedEvent = Message<"assistant.v1.ChatTitleUpdatedEvent"> & {
  /**
   * @generated from field: types.ID chat_id = 1;
   */
  chatId?: ID;

  /**
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * Describes the message assistant.v1.ChatTitleUpdatedEvent.
 * Use `create(ChatTitleUpdatedEventSchema)` to create a new message.
 */
export const ChatTitleUpdatedEventSchema: GenMessage<ChatTitleUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_assistant_v1_events, 4);

/**
 * ChatMessageEvent represents a chat message event
 *
 * @generated from message assistant.v1.ChatMessageEvent
 */
export type ChatMessageEvent = Message<"assistant.v1.ChatMessageEvent"> & {
  /**
   * @generated from oneof assistant.v1.ChatMessageEvent.event
   */
  event: {
    /**
     * @generated from field: assistant.v1.ChatMessageCreatedEvent created = 1;
     */
    value: ChatMessageCreatedEvent;
    case: "created";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message assistant.v1.ChatMessageEvent.
 * Use `create(ChatMessageEventSchema)` to create a new message.
 */
export const ChatMessageEventSchema: GenMessage<ChatMessageEvent> = /*@__PURE__*/
  messageDesc(file_assistant_v1_events, 5);

/**
 * ChatMessageCreatedEvent is emitted when a chat message is created
 * Uses the new parts-based ChatMessage structure
 *
 * @generated from message assistant.v1.ChatMessageCreatedEvent
 */
export type ChatMessageCreatedEvent = Message<"assistant.v1.ChatMessageCreatedEvent"> & {
  /**
   * @generated from field: assistant.v1.ChatMessage chat_message = 1;
   */
  chatMessage?: ChatMessage;
};

/**
 * Describes the message assistant.v1.ChatMessageCreatedEvent.
 * Use `create(ChatMessageCreatedEventSchema)` to create a new message.
 */
export const ChatMessageCreatedEventSchema: GenMessage<ChatMessageCreatedEvent> = /*@__PURE__*/
  messageDesc(file_assistant_v1_events, 6);

